import { Flex } from 'components/common/styles'
import styled from 'styled-components'
import { GRAY7 } from 'constants/colors'

export const PreviewWrapper = styled(Flex)`
  flex-wrap: wrap;
  margin-left: 26px;
`

export const PreviewItem = styled(Flex)`
  font-size: 14px;
  margin-right: 8px;
  color: ${GRAY7};
`

export const PreviewValueText = styled.span`
  margin-left: 7px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  max-width: 150px;
`
